export default "__VITE_ASSET__DvrWFVXG__"